import { pickProps } from "../utils/ObjectUtils";
import { EventGroupBy } from "./EventGroupBy";

export const getDefaultTrackingDataOptions = (opts?: {}): TrackingDataOptions => {
    let defaults = {
        retryFailedRequest: true,
        forceUpdate: false,
        suppressErrors: false,
        reverseDays: false,
        dontFetchNewData: false,
        clearDataBefore: false,
        onlyPaidsocial: true,
    };
    let props = Object.keys(defaults);
    opts = Object.assign(defaults, opts || {});
    return pickProps(opts, props);
}

export type TrackingDataOptions = {

    // Retry the request if any providers returns with an error.
    retryFailedRequest?: boolean;

    // Force the providers to fetch new data for the given request, regardless if it's already stored locally.
    forceUpdate?: boolean;

    // Suppress all errors and allow all providers to fulfill, returning results at the end.
    // Otherwise, if any provider throws an error, the whole request will.
    suppressErrors?: boolean;

    // Fulfill the request days in reverse.
    reverseDays?: boolean;

    // Tells the request or job to not ask providers for new data, just return what local data it has in db.
    dontFetchNewData?: boolean;

    // If true, the system will delete the current provider data in mongo, for the current day, before checking and refetching it.
    clearDataBefore?: boolean;

    // Include only paidsocial-attributed event data in the response, default=false
    onlyPaidsocial?: boolean;

    // This is here to be able to pass request params back to handlers
    params?: any;

}

// the actual UI/user-exposed filtering parameters.
export class TrackingDataQueryParams {

    public from: string;

    public to: string;

    public groupBy: EventGroupBy;

}
